import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  UrlTree,
} from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class PermissionGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const requiredPermission = route.data['permission'];

    const storedAccess = localStorage.getItem('access');

    if (!storedAccess) {
      return this.router.createUrlTree(['/auth/login']);
    }

    const parsedAccess = JSON.parse(storedAccess);

    const permissions: string[] = parsedAccess.permissions || [];

    if (!requiredPermission) {
      return true;
    }

    if (permissions.includes(requiredPermission)) {
      return true;
    }

    return this.router.createUrlTree(['/dashboard/home']);
  }
}
